import { render, staticRenderFns } from "./validity-display.vue?vue&type=template&id=903776d6&scoped=true"
import script from "./validity-display.vue?vue&type=script&lang=js"
export * from "./validity-display.vue?vue&type=script&lang=js"
import style0 from "./validity-display.vue?vue&type=style&index=0&id=903776d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "903776d6",
  null
  
)

export default component.exports